import React from 'react';

export default function Input({
  label,
  error,
  type = 'text',
  className = '',
  required = false,
  ...props
}) {
  return (
    <div className="mb-4">
      {label && (
        <label className="block text-base font-semibold text-gray-900 mb-2 tracking-tight">
          {label}
          {required && <span className="text-error ml-1">*</span>}
        </label>
      )}
      <input
        type={type}
        className={`w-full px-4 py-3 text-base border-2 rounded-xl focus:outline-none focus:ring-4 focus:ring-primary/20 focus:border-primary shadow-soft transition-all duration-200 bg-white ${
          error ? 'border-error focus:border-error focus:ring-error/20' : 'border-gray-300'
        } ${className}`}
        {...props}
      />
      {error && (
        <p className="mt-2 text-sm text-error font-medium">{error}</p>
      )}
    </div>
  );
}
